export default __webpack_public_path__ + "static/media/right_tick_icon.e078d885.svg";